import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

class Flash extends Component {
    render() {
        const { flash } = this.props
        return (
            <div className={ `card-box flash flash-${flash.type}` }>
                <h3>{ flash.title }</h3>
                <p>{ flash.message }</p>
            </div>
        )
    }
}

Flash.propTypes = {
    flash: PropTypes.object.isRequired
}

export default Flash


// WEBPACK FOOTER //
// ./src/client/features/flashes/components/Flash.jsx